import React, { useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  fetchAgent,
  fetchAgentHistory,
  sendAgentMessage,
  streamAgentMessage,
} from "../../processes/agentProcesses";
import { supportsStreaming } from "../../processes/helpers/sseStream";
import {
  getAgentError,
  getAgentMessages,
  getCurrentAgent,
  isAgentForbidden,
  isAgentLoading,
  isAgentSending,
  getStreamingMessageId,
} from "../../selectors/agentSelectors";
import AgentChat from "./AgentChat";

function AgentChatContainer(props) {
  const { dispatch, agent } = props;
  const agentId = props.match.params.id;
  const streamRef = useRef(null);

  useEffect(() => {
    fetchAgentHistory(dispatch, agentId);
    fetchAgent(dispatch, agentId);
  }, [dispatch, agentId]);

  // Streaming é opt-in por agente (configurado no manager) e depende do
  // navegador saber ler resposta incremental. Qualquer dúvida cai na rota
  // síncrona, que continua funcionando para todo mundo.
  const useStreaming =
    agent?.response_mode === "streaming" && supportsStreaming();

  const sendHandler = useCallback(
    (message) => {
      if (!useStreaming) return sendAgentMessage(dispatch, agentId, message);

      streamRef.current = streamAgentMessage(dispatch, agentId, message);
      return streamRef.current;
    },
    [dispatch, agentId, useStreaming]
  );

  // Sair da tela no meio do stream: aborta a conexão em vez de deixar o
  // servidor escrevendo para ninguém.
  useEffect(() => () => streamRef.current?.abort?.(), [agentId]);

  return <AgentChat onSend={sendHandler} {...props} />;
}

function mapStateToProps(state) {
  return {
    agent: getCurrentAgent(state),
    messages: getAgentMessages(state),
    loading: isAgentLoading(state),
    forbidden: isAgentForbidden(state),
    sending: isAgentSending(state),
    streamingMessageId: getStreamingMessageId(state),
    error: getAgentError(state),
  };
}

export default connect(mapStateToProps)(AgentChatContainer);
